
<div>
    <!-- contract edit -->
    <d-contract-mnt-edit
        v-model      = "create.mnt"
        :contract-id = "-1"
        :company-id  = "companyId"
        @saved       = "onSaved"
    />
    <!-- contract edit -->

    <!-- contract edit -->
    <d-contract-esc-edit
        v-model      = "create.esc"
        :contract-id = "-1"
        :company-id  = "companyId"
        @saved       = "onSaved"
    />
    <!-- contract edit -->

    <c-contract-card-iterator
        :items          = "contracts"
        :force-deselect = "contactId"
        :selected       = selected
        :item-height    = "null"
        :filter-height  = "280"
        :filter         = "textfilter"
        ref             = "contracts"
    >
        <template v-slot:toolbar>
            <div class="v-flex">
                <c-header-button label="W" @click = "onMntCreate" :tooltip="$t('contract.create.mnt')" />
                <c-header-button label="N" @click = "onEscCreate" :tooltip="$t('contract.create.esc')" />
            </div>
        </template>
        <template v-slot:filter>
            <c-contract-service-card-filter
                v-model = "filter"
                @input  = "onFilterChanged"
            />
        </template>
        <template v-slot:card="{ item }">
            <c-contract-mnt-card
                v-if        = "item.item.type.id === 3"
                :contract   = "item.item"
                :background = "`background-unset`"
                :class      = "{ 'contract-inactive': !item.item.active }"
                v-on        = "item.item.active ? { selected: onSelected } : {}"
                @saved      = "onSaved"
            />

            <c-contract-esc-card
                v-if        = "item.item.type.id === 4"
                :contract   = "item.item"
                :background = "`background-unset`"
                :class      = "{ 'contract-inactive': !item.item.active }"
                v-on        = "item.item.active ? { selected: onSelected } : {}"
                @saved      = "onSaved"
            />

        </template>
    </c-contract-card-iterator>
</div>
